import React from 'react';
import { Form, Select, Input } from 'antd';
import filterConnect from '../../../../../../common/hoc/filterConnect';

const Option = Select.Option;

class InfoACBPDP extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      isEditable,
      form,
      citizenships,
      identityDocuments,
      filterOption,
    } = this.props; // validateField
    const { getFieldDecorator } = form;

    return (
      <div className="b-form-fields">
        <div className="b-form-fields__item">
          <Form.Item label="Пол">
            {getFieldDecorator('sex', {
              rules: [],
            })(
              <Select
                style={{ width: 80 }}
                placeholder="Пол"
                disabled={!isEditable}
                getPopupContainer={trigger => trigger.parentNode}
              >
                <Option value="1">М</Option>
                <Option value="2">Ж</Option>
              </Select>
            )}
          </Form.Item>
        </div>
        <div className="b-form-fields__item">
          <Form.Item label="Гражданство">
            {getFieldDecorator('citizenship', {
              rules: [],
            })(
              <Select
                showSearch
                style={{ width: 224 }}
                name="citizenship"
                placeholder="Укажите гражданство"
                disabled={!isEditable}
                filterOption={filterOption}
                getPopupContainer={trigger => trigger.parentNode}
              >
                {citizenships &&
                  citizenships.map(item => {
                    return (
                      <Option
                        key={item.citizenshipKey}
                        value={item.citizenshipId}
                      >
                        {item.citizenship}
                      </Option>
                    );
                  })}
              </Select>
            )}
          </Form.Item>
        </div>
        <div className="b-form-fields__item">
          <Form.Item label="Место рождения">
            {getFieldDecorator('birthPlace', {
              rules: [],
            })(
              <Input
                placeholder="Укажите место рождения"
                style={{ width: 224 }}
                disabled={!isEditable}
              />
            )}
          </Form.Item>
        </div>
        <div className="b-form-fields__item">
          <Form.Item
            label={
              <span className="label-multiline">
                Документ, удостоверяющий личность
              </span>
            }
          >
            {getFieldDecorator('identityDocument', {
              rules: [],
            })(
              <Select
                showSearch
                style={{ width: 368 }}
                name="identityDocument"
                placeholder="Выберите документ"
                filterOption={filterOption}
                disabled={!isEditable}
                getPopupContainer={trigger => trigger.parentNode}
              >
                {identityDocuments &&
                  identityDocuments.map(item => {
                    return (
                      <Option
                        key={item.identityDocumentKey}
                        value={item.identityDocumentId}
                      >
                        {item.identityDocumentName}
                      </Option>
                    );
                  })}
              </Select>
            )}
          </Form.Item>
        </div>
      </div>
    );
  }
}

export default filterConnect(InfoACBPDP, ['citizenships', 'identityDocuments']);
